import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Theme } from '../../../../core/services/theme.service';
import { LanguageService, LanguageOption, Language } from '../../../../core/services/language.service';

@Component({
  selector: 'app-home-navbar',
  templateUrl: './home-navbar.component.html',
  styleUrls: ['./home-navbar.component.scss']
})
export class HomeNavbarComponent {
  @Input() isScrolled: boolean = false;
  @Input() currentTheme!: Theme;
  @Input() availableThemes: Theme[] = [];
  @Input() isMenuOpen: boolean = false;
  @Input() isDropdownOpen: boolean = false;

  @Output() smoothScrollEvent = new EventEmitter<string>();
  @Output() toggleMenuEvent = new EventEmitter<void>();
  @Output() toggleDropdownEvent = new EventEmitter<void>();
  @Output() selectThemeEvent = new EventEmitter<Theme>();

  isLanguageDropdownOpen: boolean = false;
  availableLanguages: LanguageOption[] = [];
  currentLanguage: LanguageOption;

  constructor(public languageService: LanguageService) {
    this.availableLanguages = this.languageService.availableLanguages;
    this.currentLanguage = this.languageService.getCurrentLanguageOption();
  }

  smoothScroll(sectionId: string, event?: Event): void {
    this.smoothScrollEvent.emit(sectionId);
  }

  toggleMenu(): void {
    this.toggleMenuEvent.emit();
  }

  toggleDropdown(): void {
    this.toggleDropdownEvent.emit();
  }

  selectTheme(theme: Theme, event: Event): void {
    event.stopPropagation();
    this.selectThemeEvent.emit(theme);
  }

  getThemeGradient(theme: Theme): string {
    return `linear-gradient(135deg, ${theme.colors.start} 0%, ${theme.colors.middle} 50%, ${theme.colors.end} 100%)`;
  }

  toggleLanguageDropdown(): void {
    this.isLanguageDropdownOpen = !this.isLanguageDropdownOpen;
  }

  selectLanguage(lang: Language, event: Event): void {
    event.stopPropagation();
    this.languageService.setLanguage(lang);
    this.currentLanguage = this.languageService.getCurrentLanguageOption();
    this.isLanguageDropdownOpen = false;
  }

  getLanguageFlag(langCode: Language): string {
    const flags: Record<Language, string> = {
      'ar': '🇹🇳',
      'en': '🇬🇧',
      'fr': '🇫🇷'
    };
    return flags[langCode] || '🌐';
  }
}